var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"besthit mt-2 mb-4"},[_vm._v(" Best Hit Of The Day ")])}
var staticRenderFns = []

export { render, staticRenderFns }